import { EVENT_ACTIONS, EVENT_NAMES } from './eventProperties';
import { EVENT_NAMESPACE } from './eventProperties';
export const cloneTracker = usageTracker => {
  return usageTracker.clone({
    standalone: true
  });
};
export const trackView = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_VIEWED, options);
};
export const trackClick = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.CLICK
  }));
};
export const trackTooltipOpen = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.TOOLTIP_OPEN
  }));
};
export const trackTimeFrameChange = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.TIME_FRAME_CHANGE
  }));
};
export const trackDateRangeChange = (usageTracker, options) => {
  cloneTracker(usageTracker).track(EVENT_NAMESPACE, EVENT_NAMES.COMPONENT_INTERACTED, Object.assign({}, options, {
    action: EVENT_ACTIONS.DATE_RANGE_CHANGE
  }));
};